module.exports = __webpack_public_path__ + "static/media/zog.2eb107f4.jpg";